export default "__VITE_ASSET__fb30098b__"